import { render, staticRenderFns } from "./PointOrderDetails.vue?vue&type=template&id=dd170d96&scoped=true&"
import script from "./PointOrderDetails.vue?vue&type=script&lang=js&"
export * from "./PointOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./PointOrderDetails.vue?vue&type=style&index=0&id=dd170d96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd170d96",
  null
  
)

export default component.exports